<div class="flex flex-col gap-y-8">
  <!-- Entity Selector Tabs -->
  <div class="border-b border-gray-200 mb-1">
    <nav class="flex space-x-8" aria-label="Tabs">
      <button
        *ngFor="let entity of entities"
        (click)="onEntityChange(entity.id)"
        [class]="isActiveEntity(entity.id)
          ? 'border-primary text-primary'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200">
        {{ entity.name }}
      </button>
    </nav>
  </div>

  <!-- Dynamic CRUD Content -->
  <div *ngIf="genericCRUD" class="crud-content">
    <app-generic-crud [genericCrud]="genericCRUD"></app-generic-crud>
  </div>

  <!-- Loading State -->
  <div *ngIf="!genericCRUD" class="flex justify-center items-center h-64">
    <div class="text-gray-400">Cargando configuración...</div>
  </div>
</div>
